export default __webpack_public_path__ + "static/media/login-bg.fa068427.png";